
<template>
  <div>
    <ServiceRequestList :isReport="true"></ServiceRequestList>
  </div>
</template>
<script type="text/javascript">
import ServiceRequestList from '@/Osm/ServiceRequest/components/ServiceRequestList'
  export default{
    name: 'ReportSr',
    components:{
      ServiceRequestList
    }
  }
</script>


// WEBPACK FOOTER //
// src/Dw/containers/ReportSr.vue